{
  "language": {
    "title": "Scegli la tua lingua",
    "en": "English",
    "en_US": "English",
    "nl": "Nederlands",
    "sr": "Srpski",
    "fr": "Français",
    "de": "Deutsch",
    "pt": "Português",
    "es": "Español",
    "ja": "日本語",
    "pl": "Polski",
    "it": "Italiano"
  },
  "home": {
    "welcomeMessage": "Ciao, come possiamo aiutarti?",
    "checkIn": "Registrazione",
    "independentManualCheckIn": "Nessun appuntamento",
    "integratedManualCheckIn": "Registrazione manuale",
    "checkOut": "Check-out",
    "manualCheckOut": "Check-out manuale",
    "parcelDelivery": "Consegna pacchi",
    "foodDelivery": "Consegna cibo",
    "callReception": "Chiama reception",
    "overview": "Panoramica",
    "unavailable": "La reception è al momento non disponibile."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Scegli un'opzione per registrarti",
        "manual": "Registrazione manuale",
        "code": "Registrazione con PIN o codice QR",
        "code-no-qr": "Registrazione con codice PIN"
      },
      "checkout": {
        "title": "Scegli un'opzione per il check-out",
        "manual": "Check-out con nome",
        "code": "Check-out con PIN o codice QR",
        "code-no-qr": "Check-out con codice PIN"
      }
    },
    "title": "Ora puoi scansionare il tuo codice QR o inserire il tuo codice PIN.",
    "orText": "Oppure",
    "qrScanner": {
      "checkin": {
        "title": "Scegli un'opzione per registrarti"
      },
      "checkout": {
        "title": "Scegli un'opzione per il check-out"
      },
      "btn": "Scansiona il tuo codice QR"
    },
    "hidScanner": {
      "title": "Avvicina il codice QR allo scanner qui sotto o inserisci il tuo codice PIN"
    },
    "pinOnly": {
      "title": "Inserisci il tuo codice PIN"
    },
    "pinCode": "Inserisci il tuo codice PIN",
    "manually": {
      "checkin": "Non hai un codice di registrazione?"
    },
    "status": {
      "idle": {
        "title": "Il tuo codice è in fase di scansione.",
        "message": "Attendere prego...",
        "nfc": {
          "title": "Il tuo tag è in fase di scansione.",
          "message": "Attendere prego..."
        }
      },
      "loading": {
        "title": "Il tuo codice è in fase di scansione.",
        "message": "Attendere prego...",
        "nfc": {
          "title": "Il tuo tag è in fase di scansione.",
          "message": "Attendere prego..."
        }
      },
      "error": {
        "title": "Il tuo codice non è valido.",
        "message": "Riprova!",
        "nfc": {
          "title": "Il tuo tag non è valido.",
          "message": "Per favore riprova!"
        },
        "meeting": {
          "tooEarly": {
            "title": "Sei un po' in anticipo",
            "message": "Il tuo codice è valido dalle {{validFromTime}}. La riunione inizia alle {{meetingStartTime}}."
          },
          "tooLate": {
            "title": "Questo codice è scaduto",
            "message": "La riunione è terminata alle {{meetingEndTime}}. Il tuo codice era valido fino alle {{validUntilTime}}."
          }
        }
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Ti sei registrato con successo.",
            "message": "Grazie."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Ti sei registrato con successo.",
              "message": "Grazie."
            },
            "email-sms": {
              "title": "Ti sei registrato con successo.",
              "message": "La tua persona di contatto è stata notificata."
            },
            "call-ping": {
              "title": "Ti sei registrato con successo.",
              "message": "Ora stabiliremo una chiamata telefonica con la tua persona di contatto."
            },
            "teams-call": {
              "title": "Ti sei registrato con successo.",
              "message": "Ora stabiliremo una chiamata Microsoft Teams con la tua persona di contatto."
            },
            "badge": {
              "title": "Grazie per la registrazione, il tuo badge verrà stampato.",
              "message": ""
            },
            "video-call": {
              "title": "Ti sei registrato con successo.",
              "message": "Configurazione della videochiamata con la persona di contatto."
            }
          },
          "Employee": {
            "title": "Ti sei registrato con successo.",
            "message": "Grazie.",
            "badge": {
              "title": "Grazie per la registrazione, il tuo badge verrà stampato.",
              "message": ""
            }
          },
          "Visitor": {
            "title": "Ti sei registrato con successo.",
            "message": "Grazie.",
            "badge": {
              "title": "Grazie per la registrazione, il tuo badge verrà stampato.",
              "message": ""
            }
          }
        },
        "checkout": {
          "default": {
            "title": "Hai effettuato il check-out con successo.<br/>",
            "message": "A presto."
          },
          "MeetingAttendee": {
            "title": "Hai effettuato il check-out con successo.",
            "message": "A presto."
          },
          "Employee": {
            "title": "Hai effettuato il check-out con successo.",
            "message": "A presto."
          },
          "Visitor": {
            "title": "Hai effettuato il check-out con successo.",
            "message": "A presto."
          },
          "access": {
            "title": "Hai effettuato il check-out con successo.",
            "message": "Ora puoi aprire la porta."
          }
        }
      }
    }
  },
  "missingFields": {
    "title": "Ancora qualche dettaglio prima del check-in",
    "subtitle": "I campi contrassegnati con * sono obbligatori",
    "btn": "Registrati",
    "placeholder": {
      "other": "Altro...",
      "otherInput": "Inserisci la tua opzione"
    },
    "error": {
      "required": "Non hai compilato questo campo",
      "email": "Indirizzo e-mail non valido",
      "phone": "Numero di telefono non valido"
    }
  },
  "manualCheckin": {
    "title": {
      "default": "Compila i campi.",
      "documentScanner": "Presta attenzione quando inserisci la tua carta d'identità:"
    },
    "subtitle": {
      "default": "Nota - ogni campo * è obbligatorio",
      "documentScanner": [
        {
          "parts": [
            { "text": "Il ", "bold": false },
            { "text": "lato con i caratteri <<< >>> (MRZ) ", "bold": true },
            { "text": "deve essere ", "bold": false },
            { "text": "rivolto verso il chiosco / scanner.", "bold": true }
          ]
        },
        {
          "parts": [
            { "text": "Tenere ferma la carta ", "bold": false },
            {
              "text": "fino a quando i campi vengono compilati automaticamente.",
              "bold": true
            }
          ]
        }
      ]
    },
    "noOption": "Nessuna opzione",
    "btn": "Registrati",
    "placeholder": {
      "name": "Il tuo nome *",
      "email": "La tua e-mail *",
      "phone": "Numero di cellulare",
      "contactName": "La tua persona di contatto*",
      "other": "Altro..."
    },
    "error": {
      "required": "Non hai compilato questo campo",
      "name": "Nome non valido",
      "email": "Indirizzo email non valido",
      "phone": "Numero di cellulare non valido"
    },
    "status": {
      "idle": {
        "no-contact": {
          "title": "Attendere prego...",
          "message": "La tua registrazione è in elaborazione."
        },
        "contact": {
          "title": "Attendere prego...",
          "message": "Il tuo contatto sta per essere notificato."
        }
      },
      "loading": {
        "no-contact": {
          "title": "Attendere prego...",
          "message": "La tua registrazione è in elaborazione."
        },
        "contact": {
          "title": "Attendere prego...",
          "message": "Il tuo contatto sta per essere notificato."
        }
      },
      "success": {
        "no-email-sms": {
          "title": "Ti sei registrato con successo.",
          "message": "Grazie."
        },
        "email-sms": {
          "title": "Ti sei registrato con successo.",
          "message": "La tua persona di contatto è stata notificata."
        },
        "call-ping": {
          "title": "Ti sei registrato con successo.",
          "message": "Ora stabiliremo una chiamata telefonica con la tua persona di contatto."
        },
        "teams-call": {
          "title": "Ti sei registrato con successo.",
          "message": "Ora stabiliremo una chiamata Microsoft Teams con la tua persona di contatto"
        },
        "badge": {
          "title": "Grazie per la registrazione, il tuo badge verrà stampato.",
          "message": ""
        },
        "video-call": {
          "title": "Ti sei registrato con successo.",
          "message": "Configurazione della videochiamata con la persona di contatto."
        }
      },
      "error": {
        "title": "Qualcosa è andato storto.",
        "message": "Riprova!"
      }
    },
    "documentScan": {
      "invalid": {
        "title": "Documento non valido",
        "message": "Il documento non è stato possibile verificare oppure è scaduto. Inserisci i tuoi dati manualmente."
      }
    }
  },
  "manualCheckout": {
    "title": "Inserisci il tuo nome per effettuare il check-out",
    "btn": "Check-out",
    "form": {
      "placeholder": {
        "name": "Il tuo nome completo *"
      },
      "loading": "Caricamento...",
      "noOptions": "Nessuna opzione"
    },
    "error": {
      "required": "Non hai compilato questo campo",
      "name": "Nome non valido"
    },
    "status": {
      "idle": {
        "title": "Stiamo elaborando le tue informazioni.",
        "message": "Attendere prego..."
      },
      "loading": {
        "title": "Stiamo elaborando le tue informazioni.",
        "message": "Attendere prego..."
      },
      "success": {
        "title": "Hai effettuato il check-out con successo.",
        "message": "Grazie e buona giornata."
      },
      "successAccess": {
        "title": "Hai effettuato il check-out con successo.",
        "message": "Ora puoi aprire la porta."
      },
      "error": {
        "title": "Si è verificato un errore durante il check-out.",
        "message": "Riprova!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Vuoi notificare il tuo contatto?",
      "email-sms": "Abbiamo inviato un'email/SMS al tuo contatto.<br/>Vuoi stabilire anche una chiamata con loro?"
    },
    "callBtn": "Chiama",
    "pingBtn": "Segnale",
    "smsBtn": "SMS",
    "callVideoBtn": "Videochiamata",
    "teamsCallBtn": "Chiamata Teams",
    "teamsMessageBtn": "Messaggio Teams",
    "googleChatMessageBtn": "Google Chat",
    "noBtn": "Annulla",
    "cancelBtn": "Annulla chiamata",
    "status": {
      "connecting": {
        "title": "Stabilimento chiamata.<br/>Attendere prego...",
        "message": ""
      },
      "ringing": {
        "title": "Chiamata in corso alla tua persona di contatto<br/>Attendere prego...",
        "message": ""
      },
      "ringingReception": {
        "title": "Chiamata avviata...",
        "message": ""
      },
      "open": {
        "title": "Chiamata in corso.",
        "message": ""
      },
      "close": {
        "title": "Chiamata terminata.<br/>",
        "message": ""
      },
      "closeAccess": {
        "title": "Chiamata terminata.<br/>Ora puoi aprire la porta.",
        "message": ""
      },
      "closeReception": {
        "title": "La chiamata è terminata.",
        "message": ""
      },
      "error": {
        "title": "Chiamata non stabilita.<br/>Chiamare di nuovo?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "loading": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "success": {
        "title": "L'SMS è stato inviato. Il contatto è stato notificato.",
        "message": "Grazie!"
      },
      "successAccess": {
        "title": "L'SMS è stato inviato. Il contatto è stato notificato.",
        "message": "Ora puoi aprire la porta."
      },
      "error": {
        "title": "SMS non inviato.",
        "message": "Riprova!"
      }
    }
  },
  "videoCall": {
    "title": "Videochiamata",
    "endCall": "Termina chiamata",
    "status": {
      "idle": {
        "title": "Stiamo creando una stanza video.",
        "message": "Attendere prego..."
      },
      "loading": {
        "title": "Stiamo creando una stanza video.",
        "message": "Attendere prego..."
      },
      "success": {
        "title": "La stanza video è stata creata con successo.",
        "message": "Accesso alla stanza..."
      },
      "error": {
        "title": "La stanza video non è stata creata con successo.",
        "message": "Riprova!"
      }
    }
  },
  "teamsCall": {
    "title": "Chiamata Teams",
    "controls": {
      "startCall": "Avvia chiamata",
      "endCall": "Abbandona",
      "camera": "Fotocamera",
      "cameraOff": "Fotocamera spenta",
      "mic": "Microfono",
      "micOff": "Microfono spento",
      "ringing": "Suoneria...",
      "noAnswer": "Nessuno ha risposto alla chiamata."
    },
    "status": {
      "connecting": {
        "title": "Stabilimento chiamata.<br/>Attendere prego...",
        "message": ""
      },
      "ringing": {
        "title": "Chiamata in corso alla tua persona di contatto<br/>Attendere prego...",
        "message": ""
      },
      "connected": {
        "title": "Stabilimento chiamata",
        "message": ""
      },
      "disconnected": {
        "title": "Chiamata terminata.<br/>",
        "message": ""
      },
      "disconnectedAccess": {
        "title": "Chiamata terminata.<br/>Ora puoi aprire la porta.",
        "message": ""
      },
      "error": {
        "title": "Chiamata non stabilita.<br/>Riprova",
        "message": ""
      },
      "noAnswer": {
        "title": "Nessuno ha risposto alla chiamata.<br/>Riprova.",
        "message": ""
      }
    }
  },
  "teamsMessage": {
    "status": {
      "idle": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "loading": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "success": {
        "title": "Il messaggio è stato inviato. Il contatto è stato notificato.",
        "message": "Grazie!"
      },
      "successAccess": {
        "title": "Il messaggio è stato inviato. Il contatto è stato notificato.",
        "message": "Ora puoi aprire la porta."
      },
      "error": {
        "title": "Messaggio non inviato.",
        "message": "Riprova!"
      }
    }
  },
  "googleChatMessage": {
    "status": {
      "idle": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "loading": {
        "title": "Stiamo notificando la tua persona di contatto.",
        "message": "Attendere prego..."
      },
      "success": {
        "title": "Il messaggio è stato inviato. Il contatto è stato notificato.",
        "message": "Grazie!"
      },
      "successAccess": {
        "title": "Il messaggio è stato inviato. Il contatto è stato notificato.",
        "message": "Ora puoi aprire la porta."
      },
      "error": {
        "title": "Messaggio non inviato.",
        "message": "Riprova!"
      }
    }
  },
  "packageDelivery": {
    "title": "Che gentile consegnare un pacco!",
    "subtitle": "Seleziona e notifica il destinatario",
    "subtitle1": "Premi il pulsante qui sotto per farci sapere che sei qui!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Per chi è il pacco"
      },
      "error": {
        "contact": {
          "required": "Non hai compilato questo campo"
        }
      }
    },
    "button": {
      "submit": "Notifica"
    },
    "status": {
      "loading": {
        "title": "Stiamo notificando la persona di contatto.",
        "message": "Attendere prego..."
      },
      "success": {
        "no-email-sms": {
          "title": "Grazie per la tua consegna!",
          "message": ""
        },
        "email-sms": {
          "title": "La persona di contatto è stata notificata.",
          "message": "Grazie per la tua consegna!"
        },
        "call-ping": {
          "title": "Grazie per la tua consegna!",
          "message": "Ora verrà stabilita una connessione telefonica con la persona di contatto."
        },
        "teams-call": {
          "title": "Grazie per la tua consegna!",
          "message": "Ora verrà effettuata una chiamata Microsoft Teams con la tua persona di contatto."
        },
        "video-call": {
          "title": "Grazie per la tua consegna!",
          "message": "Configurazione della videochiamata con la persona di contatto."
        }
      },
      "error": {
        "title": "Qualcosa è andato storto.",
        "message": "Riprova!"
      }
    }
  },
  "foodDelivery": {
    "title": "Che gentile consegnare del cibo!",
    "subtitle": "Seleziona e notifica il destinatario",
    "subtitle1": "Premi il pulsante qui sotto per farci sapere che sei qui!",
    "subtitle2": "",
    "input": {
      "label": {
        "contact": "Per chi è il cibo"
      },
      "error": {
        "contact": {
          "required": "Non hai compilato questo campo"
        }
      }
    },
    "button": {
      "submit": "Notifica"
    },
    "status": {
      "loading": {
        "title": "Stiamo notificando il contatto.",
        "message": "Attendere prego!"
      },
      "success": {
        "no-email-sms": {
          "title": "Grazie per la tua consegna!",
          "message": ""
        },
        "email-sms": {
          "title": "Il contatto è stato notificato.",
          "message": "Grazie per la tua consegna!"
        },
        "call-ping": {
          "title": "Grazie per la tua consegna!",
          "message": "Ora verrà stabilita una connessione telefonica con la tua persona di contatto."
        },
        "teams-call": {
          "title": "Grazie per la tua consegna!",
          "message": "Ora verrà effettuata una chiamata Microsoft Teams con la tua persona di contatto."
        },
        "video-call": {
          "title": "Grazie per la tua consegna!",
          "message": "Configurazione della videochiamata con la persona di contatto."
        }
      },
      "error": {
        "title": "Qualcosa è andato storto.",
        "message": "Riprova!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Scansiona il tuo codice QR",
    "subtitle": "Allinea il codice QR all'interno degli angoli rossi e tieni fermo il telefono.",
    "error": "Formato codice QR non valido",
    "unknownError": "Errore sconosciuto durante la scansione"
  },
  "common": {
    "backBtn": "Indietro"
  },
  "previewPDF": {
    "page": {
      "of": "di",
      "previous": "Precedente",
      "next": "Successivo"
    },
    "button": {
      "cancel": "Annulla",
      "accept": "Accetta",
      "next": "Successivo"
    },
    "title": {
      "consent": "Consenso richiesto"
    }
  },
  "offline": {
    "title": "Offline",
    "receptionMessage": "La reception digitale è al momento offline e non può essere utilizzata, la connessione internet deve essere verificata!",
    "check": "Sei un visitatore e vuoi parlare direttamente con un dipendente? Chiama {{receptionistPhone}}"
  },
  "overview": {
    "title": "Inserisci il codice per aprire la panoramica!",
    "noUsers": "Nessuna registrazione",
    "status": {
      "success": {
        "title": "Il codice è valido.",
        "message": ""
      },
      "error": {
        "title": "Il codice non è valido.",
        "message": "Riprova!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Attendere prego...",
        "message": ""
      },
      "success": {
        "title": "Check-out riuscito.",
        "message": ""
      },
      "error": {
        "title": "Qualcosa è andato storto.",
        "message": "Riprova!"
      }
    },
    "listTitle": "Elenco delle persone che si sono registrate oggi ma non hanno effettuato il check-out",
    "page": "Pagina ",
    "table": {
      "head": {
        "fullName": "Nome",
        "type": "Tipo",
        "checkedinAt": "Registrato alle",
        "host": "Host"
      },
      "type": {
        "Package": "Consegna pacchi",
        "Food": "Consegna cibo",
        "Visitor": "Visitatore",
        "MeetingAttendee": "Visitatore invitato",
        "Employee": "Dipendente",
        "Guest": "Visitatore"
      }
    },
    "confirmModal": {
      "title": "Sei sicuro di voler effettuare il check-out di {{fullName}}?",
      "cancel": "Annulla",
      "checkout": "Check-out"
    }
  },
  "wifi": {
    "title": "Connettiti alla rete Wi-Fi"
  },
  "door": {
    "external": {
      "title": "Apertura della porta",
      "subtitle": "La porta si aprirà a breve. Attendere prego..."
    },
    "control": {
      "title": "Ora puoi aprire la porta",
      "subtitle": "Premi il pulsante qui sotto!",
      "openBtn": "Apri la porta"
    },
    "status": {
      "success": {
        "title": "La porta è stata aperta",
        "message": ""
      },
      "error": {
        "title": "Qualcosa è andato storto",
        "message": "Contatta la tua persona di contatto per aprire la porta."
      },
      "loading": {
        "title": "Apertura della porta...",
        "message": ""
      }
    }
  },
  "photo": {
    "title": "Vuoi scattare una foto come parte del processo di registrazione?",
    "required": {
      "title": "Verifica Foto Richiesta!",
      "instructions": "Posizionati davanti alla fotocamera e segui le istruzioni sullo schermo.",
      "securityNotice": "Per motivi di sicurezza e verifica, è richiesta una foto durante la registrazione.",
      "privacyInfo": "Rispettiamo la tua privacy. I tuoi dati sono archiviati in modo sicuro e utilizzati solo per l'identificazione.",
      "closingMessage": "Grazie per la collaborazione."
    },
    "optional": {
      "title": "Vuoi scattare una foto come parte del processo di registrazione?",
      "instructions": "",
      "securityNotice": "Scattare una foto può aiutare a semplificare l'identificazione e migliorare la sicurezza.",
      "privacyInfo": "Rispettiamo la tua privacy. Questo passaggio è opzionale e i tuoi dati verranno gestiti in modo sicuro.",
      "closingMessage": "Puoi saltare questo passaggio se preferisci."
    },
    "subtitle": "Posizionati all'interno della cornice e rimani fermo per ottenere il miglior risultato",
    "button": {
      "cancel": "Annulla",
      "accept": "Accetta",
      "skip": "Salta",
      "next": "Successivo",
      "recapture": "Scatta di nuovo",
      "continue": "Continua"
    },
    "error": "Si è verificato un errore durante lo scatto della foto. Il processo di registrazione continuerà senza la foto."
  },
  "wayfinding": {
    "title": "Dove vuoi andare?"
  },
  "callingMenu": {
    "title": "Menu chiamate"
  },
  "bell": {
    "status": {
      "success": {
        "title": "Il campanello sta suonando",
        "message": "Qualcuno arriverà a breve."
      },
      "error": {
        "title": "Qualcosa è andato storto",
        "message": "Riprova"
      },
      "loading": {
        "title": "Connessione...",
        "message": "Attendere prego"
      }
    }
  },
  "access": {
    "control": {
      "title": "Ora puoi aprire la porta",
      "subtitle": "Premi il pulsante qui sotto.",
      "titleAuto": "Accesso automatico alla porta",
      "subtitleAuto": "La porta si aprirà automaticamente per te",
      "openBtn": "Apri"
    },
    "status": {
      "success": {
        "title": "La porta è stata aperta",
        "message": ""
      },
      "error": {
        "title": "Qualcosa è andato storto",
        "message": "Contatta la tua persona di contatto per aprire la porta."
      },
      "loading": {
        "title": "Apertura della porta...",
        "message": ""
      }
    }
  }
}
